module.exports = __webpack_public_path__ + "img/BOTB.cedc5c8f.png";